import React from 'react'
import { Box, Button, styled, Typography } from "@mui/material";
import { Link as ScrollLink } from 'react-scroll';
import { Link } from 'react-router-dom'
//img


import heroImg from '../assets/3.png';
const HeaderEgressWindowproducts = () => {

    const CustomBox = styled(Box) (({ theme }) => ({
        minHeight: '110vh',
        display: 'flex',
        justifyContent: 'center',
        // tamanhos
        verticalAlign: 'middle',
        alignItems: 'center',
        flexDirection: 'row',
        flexWrap: 'wrap',
        // tamanhos
        gap: 4,
        paddingTop: 20,
        // cor de fundo
        backgroundColor: '#088d3f',
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
        }
    }));
    const BoxText = styled(Box) (({ theme }) => ({
        flex: '1',
        position: 'absolute',
        padding: 20,
       
      
        [theme.breakpoints.down('md')]: {
            flex: '1',
            textAlign: 'center',
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            width: '95%'
        },
    }));


  return  (
<>
   
        <CustomBox component='header' style={{ backgroundImage:`url(${heroImg})`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize:'cover',
        backgroundColor: "#00000061",
        backgroundBlendMode: 'overlay',
        width: "100%" }}>
            {/*  Box text  */}
            <BoxText 
            component='section'
            >
               
                <Typography
                variant='h1'
                component= 'h1'
                width='90vw'
                maxWidth='900px'
                sx={{
                    fontWeight: 700,
                    color: '#fff',
                    '@media (max-width:420px)': {
                        marginRight: '0px',
                        maxWidth: '100%',
                        fontSize: '48px'
                        
                      }   
                }}
                >
                    Egress Windows, Area Walls, and Covers
                </Typography>

                <Typography
                variant='h5'
                component='p'
                sx={{
                    py: 3,
                    lineHeight: 1,
                    color: '#fff',
                }}
                >
                    We install egress windows anywhere in Ohio.
                </Typography>

                <Box >
                    <Button 
                    component={Link} 
                    to={'/contact'}
                    variant='contained'
                    sx={{
                        width: '130px',
                        mr: 4,
                        px: 0, 
                        py: 1,
                        margin: '20px',
                        padding: '8px',
                        fontSize: '1rem',
                        borderRadius: 1.5,
                        textTransform: 'capitalize',
                        marginLeft: '0px',
                        backgroundColor: '#4dc548',
                        color: '#000',
                        borderColor: '#4dc548',
                        '@media (max-width:420px)': {
                            width: '80vw',
                            marginLeft: '20px',
                            marginBottom: '10px'
                            
                          },
                        "&&:hover": {
                            color: '#0deb2a',
                            borderColor: '#121212',
                            backgroundColor: '#000000',
                        },
                        "&&:focus": {
                            color: '#ffffff',
                            borderColor: '#4dc548',
                        }
                    }}
                    >
                        Get Quote
                    </Button>
                    <ScrollLink to="egress-windows-products" smooth={true} duration={500}>
                    <Button 
                    
                    variant='outlined'
                    sx={{
                        width: '130px',
                        mr: 4,
                        px: 0, 
                        py: 1,
                        margin: '20px',
                        padding: '8px',
                        fontSize:'1rem',
                        textTransform: 'capitalize',
                        borderRadius: 1.5,
                        color: '#000',
                        backgroundColor: '#4dc548',
                        borderColor: '#4dc548',
                        "&&:hover": {
                            color: '#000000',
                            borderColor: '#121212',
                        },
                        "&&:focus": {
                            color: '#0deb2a',
                            borderColor: '#000000',
                        },
                        '@media (max-width:420px)': {
                            width: '80vw'
                            
                          }
                    }}
                    >
                        Learn More
                    </Button>
                    </ScrollLink>

                    

                </Box>
            </BoxText>

            <Box sx={theme => ({
                [theme.breakpoints.down('md')]:{
                    flex: '1',
                    paddingTop: '30px',
                    alignSelf: 'center',
                },
                [theme.breakpoints.up('md')]:{
                    flex: '2',
                    alignSelf: 'flex-end',
                },
            })}
            >
                
               
                
            </Box>
            
        </CustomBox>
        
        </>
    )
}

export default HeaderEgressWindowproducts